import React from "react";
import { useDispatch } from "react-redux";

import { ForwardIcon, MasterCard, Visa } from "../../assets/DirectTopUpIcon";
import {
  purchaseAirtime,
  resetPurchaseState as resetAirtimeState,
  selectPurchaseLoading as selectAirtimeLoading,
  selectPurchasePaymentUrl as selectAirtimePaymentUrl,
  selectPurchaseError as selectAirtimeError,
} from "../../features/store/airtimePurchaseSlice";
import {
  purchaseData,
  resetPurchaseState as resetDataState,
  selectPurchaseLoading as selectDataLoading,
  selectPurchasePaymentUrl as selectDataPaymentUrl,
  selectPurchaseError as selectDataError,
} from "../../features/store/dataPurchaseSlice";

import {
  purchaseElectricity,
  resetPurchaseState as resetElectricState,
  selectPurchaseLoading as selectElectricLoading,
  selectPurchasePaymentUrl as selectElectricPaymentUrl,
  selectPurchaseError as selectElectricError,
} from "../../features/store/electricityPurchaseSlice";
import {
  purchaseCable,
  resetPurchaseState as resetCableState,
  selectPurchaseLoading as selectCableLoading,
  selectPurchasePaymentUrl as selectCablePaymentUrl,
  selectPurchaseError as selectCableError,
} from "../../features/store/cablePurchaseSlice";
import {
  purchaseGiftcard,
  resetPurchaseState as resetGiftcardState,
  selectPurchaseLoading as selectGiftcardLoading,
  selectPurchasePaymentUrl as selectGiftcardPaymentUrl,
  selectPurchaseError as selectGiftcardError,
} from "../../features/store/giftcardPurchaseSlice";
import {
  purchaseTopup,
  resetPurchaseState as resetTopupState,
  selectPurchaseLoading as selectTopupLoading,
  selectPurchasePaymentUrl as selectTopupPaymentUrl,
  selectPurchaseError as selectTopupError,
} from "../../features/store/topupPurchaseSlice";
import {
  purchaseGamecard,
  resetPurchaseState as resetGamecardState,
  selectPurchaseLoading as selectGamecardLoading,
  selectPurchasePaymentUrl as selectGamecardPaymentUrl,
  selectPurchaseError as selectGamecardError,
} from "../../features/store/gamecardPurchaseSlice";
import {
  purchaseDGCoin,
  resetPurchaseState as resetDGCoinState,
  selectPurchaseLoading as selectDGCoinLoading,
  selectPurchasePaymentUrl as selectDGCoinPaymentUrl,
  selectPurchaseError as selectDGCoinError,
} from "../../features/store/dgcoinPurchaseSlice";
import { AppDispatch } from "../../redux/store";
import { useAppSelector } from "../../hooks/hooks";
import ResponseModal from "../ResponseModal";
import { TransactionData } from "../types";
import { AirtimePurchaseRequest } from "../../features/store/types/airtime-types";
import { DataPurchaseRequest } from "../../features/store/types/data-purchase-types";
import { CablePurchaseRequest } from "../../features/store/types/cable-purchase-types";
import { GiftcardPurchaseRequest } from "../../features/store/types/giftcard-purchase-types";
import { TopupPurchaseRequest } from "../../features/store/types/topup-purchase-types";
import { GamecardPurchaseRequest } from "../../features/store/types/gamecard-purchase-types";
import { DGCoinPurchaseRequest } from "../../features/store/types/dgcoin-purchase-types";
import { ElectricityPurchaseRequest } from "../../features/store/types/electricity-types";
import useClickOutside from "../../hooks/useClickOutside";
import { convertCurrencyAmount, formatCurrency } from "../../utils/utils";
import BankTransferDetails from "./BankTransferDetails";
import {
  resetPurchaseState as resetTransferState,
  setPaymentDetails as setTransferPaymentDetails,
  selectTransferPayment,
} from "../../features/store/transferPaymentSlice";

const PaymentModal = (props: TransactionData) => {
  const dispatch = useDispatch<AppDispatch>();
  const airtimeLoading = useAppSelector(selectAirtimeLoading);
  const airtimePaymentUrl = useAppSelector(selectAirtimePaymentUrl);
  const airtimeError = useAppSelector(selectAirtimeError);

  const dataLoading = useAppSelector(selectDataLoading);
  const dataPaymentUrl = useAppSelector(selectDataPaymentUrl);
  const dataError = useAppSelector(selectDataError);

  const electricityLoading = useAppSelector(selectElectricLoading);
  const electricityPaymentUrl = useAppSelector(selectElectricPaymentUrl);
  const electricityError = useAppSelector(selectElectricError);
  const cableLoading = useAppSelector(selectCableLoading);
  const cablePaymentUrl = useAppSelector(selectCablePaymentUrl);
  const cableError = useAppSelector(selectCableError);
  const giftcardLoading = useAppSelector(selectGiftcardLoading);
  const giftcardPaymentUrl = useAppSelector(selectGiftcardPaymentUrl);
  const giftcardError = useAppSelector(selectGiftcardError);
  const topupLoading = useAppSelector(selectTopupLoading);
  const topupPaymentUrl = useAppSelector(selectTopupPaymentUrl);
  const topupError = useAppSelector(selectTopupError);
  const gamecardLoading = useAppSelector(selectGamecardLoading);
  const gamecardPaymentUrl = useAppSelector(selectGamecardPaymentUrl);
  const gamecardError = useAppSelector(selectGamecardError);
  const dgcoinLoading = useAppSelector(selectDGCoinLoading);
  const dgcoinPaymentUrl = useAppSelector(selectDGCoinPaymentUrl);
  const dgcoinError = useAppSelector(selectDGCoinError);
  const transferPayment = useAppSelector(selectTransferPayment);

  const clickref = useClickOutside(props.togglePaymentModal);

  const { user } = useAppSelector((state) => state.auth);
  const { data: appData } = useAppSelector((state) => state.appData);
  const { selectedCurrency } = useAppSelector((state) => state.locale);

  const loading =
    props.type === "airtime"
      ? airtimeLoading
      : props.type == "data"
      ? dataLoading
      : props.type == "electric"
      ? electricityLoading
      : props.type == "cable"
      ? cableLoading
      : props.type == "gift_cards"
      ? giftcardLoading
      : props.type == "topup_plans"
      ? topupLoading
      : props.type == "game_cards"
      ? gamecardLoading
      : props.type == "dg_coins"
      ? dgcoinLoading
      : electricityLoading;
  const paymentUrl =
    props.type === "airtime"
      ? airtimePaymentUrl
      : props.type == "data"
      ? dataPaymentUrl
      : props.type == "electric"
      ? electricityPaymentUrl
      : props.type == "cable"
      ? cablePaymentUrl
      : props.type == "gift_cards"
      ? giftcardPaymentUrl
      : props.type == "topup_plans"
      ? topupPaymentUrl
      : props.type == "game_cards"
      ? gamecardPaymentUrl
      : props.type == "dg_coins"
      ? dgcoinPaymentUrl
      : electricityPaymentUrl;
  const error =
    props.type === "airtime"
      ? airtimeError
      : props.type == "data"
      ? dataError
      : props.type == "electric"
      ? electricityError
      : props.type == "cable"
      ? cableError
      : props.type == "gift_cards"
      ? giftcardError
      : props.type == "topup_plans"
      ? topupError
      : props.type == "game_cards"
      ? gamecardError
      : props.type == "dg_coins"
      ? dgcoinError
      : electricityError;

  const [responseModal, setResponseModal] = React.useState(false);
  const [responseMessage, setResponseMessage] = React.useState("");
  const [responseStatus, setResponseStatus] = React.useState<
    "success" | "error"
  >("success");
  // track which payment method is currently processing locally
  const [processingMethod, setProcessingMethod] = React.useState<
    "ATM" | "TRANSFER" | "COIN" | "POINT" | null
  >(null);

  const closeResponseModal = () => {
    setResponseModal(false);
  };

  // Redirect to payment URL if available
  React.useEffect(() => {
    if (paymentUrl) {
      window.location.href = paymentUrl;
    }
  }, [paymentUrl]);

  // clear local processing flag when global loading stops
  React.useEffect(() => {
    if (!loading) {
      setProcessingMethod(null);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!props.isOpen) {
      dispatch(resetTransferState());
    }
  }, [props.isOpen, dispatch]);

  if (!props.isOpen) return null;

  function getOriginalPrice(discountedPrice: number, discountPercent: number) {
    const originalPrice = discountedPrice / (1 - discountPercent / 100);
    return originalPrice;
  }

  const currencies = appData.currencies || [];
  const getCurrencyById = (currencyId?: number) =>
    currencies.find((currency: any) => currency.id === currencyId);
  const dgCoinCurrency =
    currencies.find((currency: any) => currency.symbol === "DG") ||
    currencies.find((currency: any) =>
      String(currency.name || "")
        .toLowerCase()
        .includes("dg coin")
    );

  const formatConvertedPrice = (
    amount: number | string,
    currencyId?: number
  ) => {
    const fromCurrency =
      getCurrencyById(currencyId) || selectedCurrency || currencies[0];
    const toCurrency = selectedCurrency || fromCurrency;
    const numericAmount = Number(amount);
    const converted = convertCurrencyAmount(
      numericAmount,
      fromCurrency,
      toCurrency
    );
    return {
      symbol: toCurrency?.symbol || "",
      value: formatCurrency(converted),
    };
  };

  const formatDGCoinPrice = (amount: number | string, currencyId?: number) => {
    const fromCurrency = getCurrencyById(currencyId) || dgCoinCurrency;
    if (!fromCurrency || !dgCoinCurrency) {
      return formatCurrency(Number(amount));
    }
    const numericAmount = Number(amount);
    const converted = convertCurrencyAmount(
      numericAmount,
      fromCurrency,
      dgCoinCurrency
    );
    return formatCurrency(converted);
  };

  const walletPrice = Number(props.selectedPlan?.wallet_price ?? 0);
  const planCurrencyId = props.selectedPlan?.price_currency_id;
  const hasDiscount = Number(props.selectedPlan?.discount ?? 0) > 0;
  const originalPrice = hasDiscount
    ? getOriginalPrice(walletPrice, Number(props.selectedPlan?.discount ?? 0))
    : null;
  const discountAmount =
    originalPrice !== null ? originalPrice - walletPrice : null;
  const convertedWallet = formatConvertedPrice(walletPrice, planCurrencyId);
  const convertedOriginal =
    originalPrice !== null
      ? formatConvertedPrice(originalPrice, planCurrencyId)
      : null;
  const convertedDiscount =
    discountAmount !== null
      ? formatConvertedPrice(discountAmount, planCurrencyId)
      : null;
  const dgCoinValue = formatDGCoinPrice(walletPrice, planCurrencyId);
  const showBankTransfer =
    selectedCurrency?.symbol === "₦" ||
    selectedCurrency?.name?.toLowerCase().includes("naira");

  const getTransferAmount = () => {
    if (props.type === "airtime" || props.type === "electric") {
      const asNumber = Number(props.additionalInputValue);
      return Number.isFinite(asNumber)
        ? asNumber
        : Number(props.selectedPlan.wallet_price);
    }
    return Number(props.selectedPlan.wallet_price);
  };

  // Generic payment handler for ATM, Bank Transfer and Coin (points)
  const handlePayment = async (
    method: "ATM" | "TRANSFER" | "COIN" | "POINT"
  ) => {
    // reset any previous purchase state and mark this method as processing
    switch (props.type) {
      case "airtime":
        dispatch(resetAirtimeState());
        break;
      case "data":
        dispatch(resetDataState());
        break;
      case "electric":
        dispatch(resetElectricState());
        break;
      case "cable":
        dispatch(resetCableState());
        break;
      case "gift_cards":
        dispatch(resetGiftcardState());
        break;
      case "topup_plans":
        dispatch(resetTopupState());
        break;
      case "game_cards":
        dispatch(resetGamecardState());
        break;
      case "dg_coins":
        dispatch(resetDGCoinState());
        break;
      default:
        // unknown product
        setResponseStatus("error");
        setResponseMessage("Unsupported product type.");
        setResponseModal(true);
        return;
    }
    setProcessingMethod(method);
    if (method === "TRANSFER") {
      setResponseModal(false);
      dispatch(resetTransferState());
    } else if (method === "ATM") {
      setResponseModal(false);
    } else {
      setResponseModal(true);
      setResponseStatus("success"); // Default to success, will be updated
      setResponseMessage("Processing your payment...");
    }

    let payload:
      | AirtimePurchaseRequest
      | DataPurchaseRequest
      | ElectricityPurchaseRequest
      | CablePurchaseRequest
      | GiftcardPurchaseRequest
      | TopupPurchaseRequest
      | GamecardPurchaseRequest
      | DGCoinPurchaseRequest;
    switch (props.type) {
      case "airtime":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          amount: Number(props.additionalInputValue),
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as AirtimePurchaseRequest;
        break;
      case "data":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as DataPurchaseRequest;
        break;
      case "electric":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          amount: Number(props.additionalInputValue),
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as ElectricityPurchaseRequest;
        break;
      case "cable":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as CablePurchaseRequest;
        break;
      case "gift_cards":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as GiftcardPurchaseRequest;
        break;
      case "topup_plans":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as TopupPurchaseRequest;
        break;
      case "game_cards":
        payload = {
          unique_number: props.unique_number || "",
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as GamecardPurchaseRequest;
        break;
      case "dg_coins":
        payload = {
          plan_id: props.selectedPlan.id,
          payment_method: method,
          source: "WEB",
          currency_id: selectedCurrency?.id,
        } as DGCoinPurchaseRequest;
        break;
      default:
        setResponseStatus("error");
        setResponseMessage("Unsupported product type.");
        return;
    }

    try {
      let action;
      switch (props.type) {
        case "airtime":
          action = purchaseAirtime(payload as AirtimePurchaseRequest);
          break;
        case "data":
          action = purchaseData(payload as DataPurchaseRequest);
          break;
        case "electric":
          action = purchaseElectricity(payload as ElectricityPurchaseRequest);
          break;
        case "cable":
          action = purchaseCable(payload as CablePurchaseRequest);
          break;
        case "gift_cards":
          action = purchaseGiftcard(payload as GiftcardPurchaseRequest);
          break;
        case "topup_plans":
          action = purchaseTopup(payload as TopupPurchaseRequest);
          break;
        case "game_cards":
          action = purchaseGamecard(payload as GamecardPurchaseRequest);
          break;
        case "dg_coins":
          action = purchaseDGCoin(payload as DGCoinPurchaseRequest);
          break;
        default:
          setResponseStatus("error");
          setResponseMessage("Unsupported product type.");
          return;
      }

      const res: any = await dispatch(action).unwrap();

      if (method === "TRANSFER" && res?.data?.account_number) {
        dispatch(
          setTransferPaymentDetails({
            bank: res.data.bank_name,
            bank_name: res.data.bank_name,
            account_name: res.data.account_name,
            account_number: res.data.account_number,
            reference: res.data.reference,
            accountExpiry: res.data.accountExpiry,
            amount: res.data.amount,
          })
        );
        setProcessingMethod(null);
        setResponseModal(false);
        return;
      }

      setResponseStatus("success");
      setResponseMessage(res?.message || "Payment successful!");
    } catch (err: any) {
      // unwrap throws the rejected action payload or error
      const msg =
        err?.message || err?.payload?.message || err?.error || "Payment failed";
      setResponseStatus("error");
      setResponseMessage(msg);
      setResponseModal(true);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div
        ref={clickref}
        className="bg-white dark:bg-black rounded-lg p-6 w-[290px] bp:w-full max-w-md mx-[10px] h-[550px] bp:h-[684px] overflow-y-auto"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xs bp:text-base font-semibold text-black dark:text-white">
            Checkout
          </h2>
          <button
            onClick={props.togglePaymentModal}
            className="text-[#475467] dark:text-white bg-[#F4F4F5] dark:bg-[#FFFFFF1A] rounded-2xl h-6 w-5 hover:text-gray-700  dark:hover:text-gray-200"
          >
            &times;
          </button>
        </div>

        {Number(props.selectedPlan?.point_bonus ?? 0) > 0 && (
          <div className="bg-[#FFF9E7] h-10 dark:bg-[#DC6803] p-3 rounded-3xl mb-6 flex items-center justify-center">
            <img
              src="/png/Coins.png"
              alt="Coins"
              className="w-[24px] h-[24px]"
            />
            <p className="text-[10px] bp:text-sm text-[#DC6803] dark:text-white">
              You will earn DG Points from this purchase
            </p>
          </div>
        )}

        <div className="flex items-center gap-3 mb-2 bp:mb-6">
          <div>
            <img
              src={props.selectedPlan.image_url}
              alt="product_img"
              className="w-[102px] h-[75px] bp:h-[102px]"
            />
          </div>
          <div className="border border-border-border1 dark:border-tabs p-2 rounded-lg w-[368px] h-[75px] bp:h-[102px]">
            <h3 className="font-bold text-xs bp:text-base font-lt text-black dark:text-white">
              {props.type} purchase
            </h3>
            <p className="font-lt text-[10px] bp:text-sm  text-gray-500 dark:text-gray-400">
              {props.selectedPlan?.category?.provider?.name} :{" "}
              {props.selectedPlan?.name} ( {props.selectedPlan?.category?.name})
            </p>
            <div className="flex items-center mt-1 gap-2">
              <div className="bg-[#039EF2] text-white px-2 rounded-2xl flex items-center gap-1">
                <img
                  src="/png/Coins.png"
                  alt="Coins"
                  className="w-[20px] h-[20px]"
                />
                <span className="text-[10px] bp:text-xs font-semibold">
                  {dgCoinValue}
                </span>
              </div>
              <span className="text-xs bp:text-base text-black dark:text-white">
                {convertedWallet.symbol}
                {convertedWallet.value}
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-700 py-4">
          <div className="flex justify-between mb-1 bp:mb-2 font-inter">
            <span className="text-[#667085] dark:text-white text-[10px] bp:text-sm">
              Subtotal
            </span>
            <span className="text-black text-[10px] bp:text-sm dark:text-white ">
              {hasDiscount && convertedOriginal
                ? `${convertedOriginal.symbol}${convertedOriginal.value}`
                : `${convertedWallet.symbol}${convertedWallet.value}`}
            </span>
          </div>
          {hasDiscount && convertedDiscount && (
            <div className="flex justify-between mb-1 bp:mb-2 font-inter">
              <span className="text-[#667085] text-[10px] bp:text-sm dark:text-white">
                Discount
              </span>
              <span className="text-black dark:text-white text-[10px] bp:text-sm">
                {convertedDiscount.symbol}
                {convertedDiscount.value}
              </span>
            </div>
          )}
        </div>

        <div className="border-t border-dashed border-gray-200 dark:border-white py-4 font-inter">
          <div className="flex justify-between items-center">
            <span className="text-[#101828] text-[10px] bp:text-sm dark:text-gray-400">
              Total
            </span>
            <div className="flex items-center">
              <div className="bg-[#039EF2] text-white  px-2 py-1 rounded-2xl gap-1 flex items-center mr-2">
                <div className="w-4 h-4  flex items-center">
                  <img
                    src="/png/Coins.png"
                    alt="Coins"
                    className="w-[20px] h-[20px]"
                  />
                </div>
                <span className=" text-[10px] bp:text-xs font-inter font-semibold">
                  {dgCoinValue}
                </span>
              </div>
              <span className="text-[10px] bp:text-sm font-bold text-black dark:text-white">
                {convertedWallet.symbol}
                {convertedWallet.value}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-2 bp:mt-6 bg-[#EAECF0] dark:bg-[#FFFFFF1A] rounded-lg p-4">
          {transferPayment.paymentDetails ? (
            <BankTransferDetails />
          ) : (
            <>
              {/* Coin payment button */}
              {user &&
                props.type !== "dg_coins" &&
                user.dg_coin_wallet_balance >= dgCoinValue && (
                  <>
                    <button
                      className={`relative h-[50px] bp:h-[60px] w-full max-w-md flex items-center justify-between rounded-lg p-4 overflow-hidden ${
                        loading && processingMethod !== "COIN"
                          ? "opacity-60 cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        backgroundImage: `url(/images/LeaderBoardBG.jpeg)`,
                        backgroundPosition: "center bottom",
                        backgroundSize: "cover",
                      }}
                      onClick={() => handlePayment("COIN")}
                      disabled={loading && processingMethod !== "COIN"}
                    >
                      {/* Left side with coin icon */}
                      <div className="flex items-center gap-3 z-10">
                        <div className="flex items-center justify-center">
                          <div className="w-6 h-6 mr-1 flex items-center gap-1">
                            <img
                              src="/png/Coins.png"
                              alt="Coins"
                              className="w-[40px] h-[40px]"
                            />
                            <div className="flex flex-col mt-2">
                              <p className="text-[8px] font-medium text-blue-100">
                                Pay with available coins
                              </p>
                              <p className="text-xl font-lt font-bold text-white">
                                {processingMethod === "COIN" && loading
                                  ? "Processing..."
                                  : user.dg_coin_wallet_balance}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side with arrow icon */}
                      <div className="bg-white  w-5 h-5 bp:w-6 bp:h-6 flex items-center rounded-full p-2 z-10">
                        <ForwardIcon />
                      </div>
                    </button>

                    <div className="flex items-center my-4">
                      <div className="flex-grow h-px bg-gray-200"></div>
                      <span className="px-3 text-gray-500 text-sm uppercase">
                        OR
                      </span>
                      <div className="flex-grow h-px bg-gray-200"></div>
                    </div>
                  </>
                )}

              {/* Bank Transfer Payment Button */}

              {showBankTransfer && (
                <>
                  <button
                    className={`w-full bg-white dark:bg-[#FFFFFF1A] border border-gray-300 dark:border-gray-700 rounded-lg p-3 flex items-center justify-center text-black dark:text-white ${
                      loading && processingMethod !== "TRANSFER"
                        ? "opacity-60 cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() => handlePayment("TRANSFER")}
                    disabled={loading && processingMethod !== "TRANSFER"}
                  >
                    <div className="flex space-x-2 mr-2"></div>
                    <span className="text-[10px] dark:text-white bp:text-base font-semibold">
                      {processingMethod === "TRANSFER" && loading
                        ? "Processing..."
                        : "Pay with Bank Transfer"}
                    </span>
                  </button>

                  <div className="flex items-center my-4">
                    <div className="flex-grow h-px bg-gray-200"></div>
                    <span className="px-3 text-gray-500 text-sm uppercase">
                      OR
                    </span>
                    <div className="flex-grow h-px bg-gray-200"></div>
                  </div>
                </>
              )}

              {/* ATM Payment Button */}
              <button
                className={`w-full bg-white dark:bg-[#FFFFFF1A] border border-gray-300 dark:border-gray-700 rounded-lg p-3 flex items-center justify-center text-black dark:text-white ${
                  loading && processingMethod !== "ATM"
                    ? "opacity-60 cursor-not-allowed"
                    : ""
                }`}
                onClick={() => handlePayment("ATM")}
                disabled={loading && processingMethod !== "ATM"}
              >
                <div className="flex space-x-2 mr-2">
                  <span className="w-8">
                    <Visa />
                  </span>
                  <span className="w-8">
                    <MasterCard />
                  </span>
                </div>
                <span className="text-[10px] dark:text-white bp:text-base font-semibold">
                  {processingMethod === "ATM" && loading
                    ? "Processing..."
                    : "Pay with ATM Card"}
                </span>
              </button>

              {error && (
                <div className="text-red-500 text-xs mt-2 text-center">
                  {error}
                </div>
              )}
            </>
          )}
          <ResponseModal
            isOpen={responseModal}
            onClose={closeResponseModal}
            status={responseStatus}
            message={responseMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
